import React, { useImperativeHandle, forwardRef } from 'react';
import { userCode, username } from '../../../services/ApiService';
import ButtonService from '../ButtonService';

import { useFormik } from 'formik';
import * as Yup from 'yup'
import CreateEditModalMaster from '../CreateEditModalMaster';
import { Input, showToast, TickBox } from '../../../components/ui';
import { Typography } from '@mui/material';

const CreateEditSetValue = forwardRef((props, ref) => {
    const { isModal, handleClick, titleModal, title, param, selectedData, getData } = props

    const simpanLocal = () => {
        if (isModal) {
            const data = {
                "setValues": {
                    ...formik.values,
                    rowStatus: formik?.values?.rowStatus || 'ACT',
                    titleModal,
                    userCode,
                }
            }
            localStorage.setItem(username + "-DataSetValues", JSON.stringify(data));
        }
    }

    useImperativeHandle(ref, () => ({

        localSave() {
            simpanLocal()
        }

    }));

    const validationSchema = Yup.object().shape({
        accessMode: Yup.string().trim().required('This field is required.'),
        setAsDefault: Yup.boolean(),
        attribute: Yup.string().trim().required('This field is required.'),
        value: Yup.string().trim().required('This field is required.'),
        description: Yup.string().trim().required('This field is required.'),
        explanation: Yup.string().trim().required('This field is required.'),
    })

    const formik = useFormik({
        initialValues: selectedData?.id ? { ...selectedData } : {
            accessMode: '',
            setAsDefault: false,
            attribute: '',
            value: '',
            description: '',
            explanation: '',
        },
        validationSchema,
        onSubmit: (values) => Save(values)
    })

    const Save = (payload) => {
        if (payload?.accessMode === '') {
            return showToast({ type: 'error', message: 'Access Mode is Required!' });
        }

        if (payload?.attribute === '') {
            return showToast({ type: 'error', message: 'Attribute is Required!' });
        }

        if (payload?.value === '') {
            return showToast({ type: 'error', message: 'Value is Required!' });
        }

        if (payload?.description === '') {
            return showToast({ type: 'error', message: 'Description is Required!' });
        }

        if (payload?.explanation === '') {
            return showToast({ type: 'error', message: 'Explanation is Required!' });
        }

        const data =
        {
            "setValues": {
                "rowStatus": "ACT",
                "id": payload?.id,
                "accessMode": payload?.accessMode,
                "setAsDefault": payload?.setAsDefault,
                "attribute": payload?.attribute,
                "value": payload?.value,
                "description": payload?.description,
                "explanation": payload?.explanation,
                "userCode": userCode
            }
        }

        ButtonService.Save(titleModal, title, param, data, () => {
            getData(1, 50, []);
            handleClick();
        });
    }

    function handleChange(name, value) {
        formik.setFieldValue(name, !value);
    }

    const mainContainer = (
        <form onSubmit={formik.handleSubmit} style={{ marginTop: '12px' }}>
            <Input
                name="accessMode"
                label="Access Mode"
                value={formik.values.accessMode}
                onBlur={formik.handleBlur}
                error={formik.touched.accessMode && Boolean(formik.errors.accessMode)}
                helperText={formik.touched.accessMode && formik.errors.accessMode}
                onChange={(e) => formik.setFieldValue('accessMode', e.target.value)}
                formControlProps={{
                    sx: {
                        width: '100%',
                        // marginTop: '16px'
                    }
                }}
            />

            <div style={{ marginTop: '16px' }}>
                <TickBox
                    size={'small'}
                    label={
                        <Typography
                            sx={{
                                color: 'var(--Blue-Primary-1, #083A50)',
                                fontFamily: 'Nunito',
                                fontSize: '12px !important',
                                fontStyle: 'normal',
                                fontWeight: '500',
                                lineHeight: '20px',
                            }}
                        >
                            Set as Default
                        </Typography>
                    }
                    checked={formik.values.setAsDefault}
                    onChange={() => handleChange('setAsDefault', formik.values.setAsDefault)}
                />
            </div>

            <Input
                name="attribute"
                label="Attribute"
                value={formik.values.attribute}
                onBlur={formik.handleBlur}
                error={formik.touched.attribute && Boolean(formik.errors.attribute)}
                helperText={formik.touched.attribute && formik.errors.attribute}
                onChange={(e) => formik.setFieldValue('attribute', e.target.value)}
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
            />

            <Input
                name="value"
                label="Value"
                value={formik.values.value}
                onBlur={formik.handleBlur}
                error={formik.touched.value && Boolean(formik.errors.value)}
                helperText={formik.touched.value && formik.errors.value}
                onChange={(e) => formik.setFieldValue('value', e.target.value)}
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
            />

            <Input
                id='description'
                name="description"
                label="Description"
                multiline
                fullWidth
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
                inputBaseProps={{
                    rows: 4,
                    sx: {
                        padding: '8px',
                    },
                }}
                value={formik.values.description}
                onBlur={formik.handleBlur}
                error={formik.touched.description && Boolean(formik.errors.description)}
                helperText={formik.touched.description && formik.errors.description}
                onChange={(e) => formik.setFieldValue('description', e.target.value)}
            />

            <Input
                id='explanation'
                name="explanation"
                label="Explanation"
                multiline
                fullWidth
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
                inputBaseProps={{
                    rows: 4,
                    sx: {
                        padding: '8px',
                    },
                }}
                value={formik.values.explanation}
                onBlur={formik.handleBlur}
                error={formik.touched.explanation && Boolean(formik.errors.explanation)}
                helperText={formik.touched.explanation && formik.errors.explanation}
                onChange={(e) => formik.setFieldValue('explanation', e.target.value)}
            />
        </form>
    )

    return (
        <>
            {
                isModal && (
                    <CreateEditModalMaster
                        isModal={isModal}
                        titleModal={titleModal}
                        title={title}
                        mainContainer={mainContainer}
                        handleClick={handleClick}
                        handleSave={() => Save(formik.values)}
                    />
                )
            }
        </>
    )
})

export default CreateEditSetValue